import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {}

interface TempPasswordDataShape {
	tempPassword: string
	tempPasswordExpiresAt: number
	tempPasswordCreatedAt?: number
}

interface ResponseDataShape {
	success: boolean
	data: TempPasswordDataShape
}

export async function userTempPasswordCreateApi(token: string | null) {
	const endpoint = "/user/temp-password/create/v1"
	const requester = new ApiRequester<RequestDataShape, ResponseDataShape>(endpoint)
	const response = await requester.sendRequest({}, token)
	return response.data
}
